// extracted by mini-css-extract-plugin
var _1 = "Px2b8k3x";
var _2 = "k95nWxKE";
var _3 = "dT4MXMHp";
var _4 = "TGmzbpMQ";
var _5 = "SPTYVgFf";
export { _1 as "deleteBtn", _2 as "label", _3 as "option", _4 as "title", _5 as "weight" }
